const requests = {
    symptomList: '/symptoms',
    supplements: '/supplements/',
    search: '/supplements',
}

export default requests;